import { createApi, fakeBaseQuery } from '@reduxjs/toolkit/query/react';
import { BackendErrorType } from '../services/helpers';

export const rootApi = createApi({
  reducerPath: 'api',
  baseQuery: fakeBaseQuery<BackendErrorType>(),
  tagTypes: [
    'UserTerms',
    'RecurringBuys',
    'CustomerAccount',
    'CustomerPersonalData',
    'FiatDeposit',
    'CryptoDeposit',
    'PendingFiatDeposit',
    'PendingCryptoDeposit',
    'UserProfile',
    'LoginMethods',
    'Rewards',
    'PendingTransactions',
    'PortfolioGainLoss',
    'Leads',
    'Countries',
    'Assets',
  ],
  endpoints: builder => ({}),
});
